module.exports = __webpack_public_path__ + "img/icon-upload.5137dbce.png";